<div class="_hot-spot"
     (mouseenter)="checkTitleWidth()">
    <div class="_wrapper">
        <div class="_dotContainer">
            <div class="_dot"></div>
        </div>
        <div class="_titleContainer"
             [style.--titleWidth]="titleWidth+'px'">
            <p #titleElement
               class="_title h5">
                {{title}}
            </p>
        </div>
    </div>
</div>
